import { SEARCH_PATH } from 'modules/search/constants'
import { getObjectUtil } from 'packages/src'

const getQuerySearchSelect = state => getObjectUtil(state, SEARCH_PATH.QUERY) || ''

export default getQuerySearchSelect
